
import {Component} from 'vue-property-decorator';
import LandingCreateForm from './create.vue';
import { pick } from 'lodash';

@Component
export default class Edit extends LandingCreateForm {
  child: boolean = true;
  
  get modalTitle(){
    return this.t('Duplicate Landing')
  }

  async load() {
   this.landing_id = this.$store.getters.selectedItem.id;

    await this.landingApi.get(this.landing_id).then((data: any) => {
      this.form = pick(data, [
        'countryId',
        'name',
        'offers',
        'status',
        'tags',
        'url',
        'workspaceId'
      ]);
    });
  }

  loadData() {
    this.$store.commit('loading', true);
    return this.load()
      .then((data: any) => {
        this.landing_id = '';

        this.form.name = this.form.name + ' (' + this.t('____x.copy') + ')';
        this.show = true;

        this.oldHash = this.getCurrentHash();
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }
}
